export function getColibrioConfig() {
  return {
    clientId: process.env.VUE_APP_COLIBRIO_CLIENT_ID || 'ekitabu-test',
    scriptUrl: process.env.VUE_APP_COLIBRIO_SCRIPT_URL || 'https://ekitabu-test.colibriocirrus.com/cirrus-reader-1.0.0.min.js',
    configVersion: process.env.VUE_APP_COLIBRIO_CONFIG_VERSION  || '2025-10-22T23:01:00Z',
    keyPrefix: process.env.VUE_APP_COLIBRIO_KEY_PREFIX || '',
  };
}

export function buildEpubKey(bookId, unencryptedFilePath) {
  const config = getColibrioConfig();
  const uuidParts = bookId.split('/');
  const uuid = uuidParts[uuidParts.length - 1];

  if (!uuid) {
    throw new Error('Invalid bookId: cannot extract UUID');
  }

  if (!unencryptedFilePath) {
    throw new Error('unencryptedFilePath is required');
  }

  const pathParts = unencryptedFilePath.split('/');
  const filename = pathParts[pathParts.length - 1];

  if (!filename) {
    throw new Error('Invalid unencryptedFilePath: cannot extract filename');
  }

  return `${config.keyPrefix}product/${uuid}/private/${filename}`;
}

let scriptLoadingPromise = null;

export function loadColibrioScript() {
  if (window.CirrusReader) {
    return Promise.resolve();
  }

  if (scriptLoadingPromise) {
    return scriptLoadingPromise;
  }

  scriptLoadingPromise = new Promise((resolve, reject) => {
    const config = getColibrioConfig();
    const script = document.createElement('script');
    script.src = config.scriptUrl;
    script.type = 'text/javascript';
    script.onload = () => {
      scriptLoadingPromise = null;
      resolve();
    };
    script.onerror = (error) => {
      scriptLoadingPromise = null;
      reject(error);
    };
    document.head.appendChild(script);
  });

  return scriptLoadingPromise;
}
